
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-breadcrumbs [crumbs]="breadCrumbs"></app-st-breadcrumbs>
    </div>
  </div>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'top-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
    </div>
    <span><h2>Company Information</h2></span>

    <div class="row pt-2">
      <div class="col">
        <span><strong>Name: </strong></span><span>{{nonprofitDonorFullAttr['companyName']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Ein: </strong></span><span>{{nonprofitDonorFullAttr['ein']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Phone Number: </strong></span><span>{{nonprofitDonorFullAttr['phoneNumber']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Email: </strong></span><span>{{nonprofitDonorFullAttr['email']}}</span>
      </div>
    </div>
    <br>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Address: </strong></span><br>
        <span>{{nonprofitDonorFullAttr['taxFilingStreetAddress']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span>{{nonprofitDonorFullAttr['taxFilingCity']}}, {{nonprofitDonorFullAttr['taxFilingState']}} {{nonprofitDonorFullAttr['taxFilingZipCode']}} USA</span>
      </div>
    </div>
    <br>
    <h3>Company Characteristics</h3>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Organization Code: </strong> {{nonprofitDonorFullAttr['organizationCode']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Foundation Code: </strong> {{nonprofitDonorFullAttr['foundationCode']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Ntee Parent Code: </strong> {{nonprofitDonorFullAttr['nteeParentCode']}}</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span><strong>Ntee Code: </strong> {{nonprofitDonorFullAttr['nteeParentCode']}}</span>
      </div>
    </div>

    <h3>Company Financials</h3>
    <div *ngFor="let row of this.companyFinancialsByYear">
      <div class="row pt-2">
        <div class="col">
          <span><strong>Tax Year: </strong></span><span>{{row['taxYear']}}</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span><strong>Total Revenue: </strong></span><span>{{row['totalRevenue']}}</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span><strong>Total Expenses: </strong></span><span>{{row['totalExpenses']}}</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span><strong>Total Assets: </strong></span><span>{{row['totalAssets']}}</span>
        </div>
      </div>
      <br>
      <h4>Key Employees</h4>
      <div class="row pt-3" *ngFor="let keyEmployee of row['keyEmployeesList']">
        <div class="col">
          <span><strong>Name: </strong></span><span>{{keyEmployee['personName']}}</span>
        </div>
        <div class="col">
          <span><strong>Title: </strong></span><span>{{keyEmployee['titleTxt']}}</span>
        </div>
        <div class="col">
          <span><strong>Phone #: </strong></span><span>{{keyEmployee['phoneNum']}}</span>
        </div>
      </div>
    </div>
    <br><br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'bottom-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
    </div>
  </div>
</div>
